import type { Definition } from '@exodus/dependency-types';

import type { Airdrop } from './module.js';

type Dependencies = {
  airdrop: Airdrop;
};

const createAirdropApi = ({ airdrop }: Dependencies) => {
  return {
    airdrop: {
      claim: airdrop.claim,
    },
  };
};

const airdropApiDefinition = {
  id: 'airdropApi',
  type: 'api',
  factory: createAirdropApi,
  dependencies: ['airdrop'],
} as const satisfies Definition;

export default airdropApiDefinition;
